import { render } from "./RequestSupportBtn.vue?vue&type=template&id=14fd4310&ts=true"
import script from "./RequestSupportBtn.vue?vue&type=script&lang=ts"
export * from "./RequestSupportBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__